import React, { useRef } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import RoadmapWrapper from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/roadmap-wrapper/index.tsx';
import Footer from '../common/footer/index.tsx';
import Header from '../common/header/index.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

export const TimelineMacroView = () => {
	const roadmapContainerRef = useRef<HTMLDivElement>(null);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.container}>
			<Header />
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.main}>
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={
						ff('com.atlassian.rm.jpo.transposition')
							? styles.roadmapContainerTransposed
							: styles.roadmapContainer
					}
					ref={roadmapContainerRef}
				>
					<RoadmapWrapper containerRef={roadmapContainerRef} />
				</div>
			</div>
			<Footer />
		</div>
	);
};
